import React, { Component } from "react";
import { connect } from "react-redux";
import registerActionCreators from "../../../store/Auth/Register/actionCreators";
import MainAccountFields from "./MainAccountFields";
import FileInputsFields from "./FileInputFields";
import GTM from "../../../common/services/GTM";
import { BeatLoader } from "react-spinners";

class RegisterForm extends Component {
    componentDidMount() {
        GTM.dispatch({
            event: "pageView",
            pageUrl: `/register`,
        });
    }

    submit = values => {
        const { register } = this.props;
        register(values);
    };

    render() {
        const {
            step,
            nextStep,
            prevStep,
            user,
            initialValues,
            registerForm,
            isFormSubmitting,
        } = this.props;

        switch (step) {
            case 0:
                return (
                    <div className="loading">
                        <BeatLoader color={"#ffffff"} width={"70px"} />
                    </div>
                );
            case 1:
                return (
                    <MainAccountFields
                        {...{
                            onSubmit: nextStep,
                            user,
                            initialValues,
                        }}
                    />
                );
            case 2:
                return (
                    <div>
                        {isFormSubmitting && (
                            <div className="loading">
                                <BeatLoader color={"#ffffff"} width={"70px"} />
                            </div>
                        )}
                        <FileInputsFields
                            {...{
                                onSubmit: this.submit,
                                user,
                                prevStep,
                                registerForm,
                            }}
                        />
                    </div>
                );
            default:
                return <div />;
        }
    }
}

const dispatchToProps = {
    register: registerActionCreators.register.create,
    nextStep: registerActionCreators.nextStep.create,
    prevStep: registerActionCreators.prevStep.create,
};

const mapStateToProps = ({ Register, Auth, form: { register } }) => ({
    step: Register.step,
    registerForm: register,
    user: Auth.user,
    initialValues: {
        firstName: Auth.user.firstName,
        lastName: Auth.user.lastName,
        email: Auth.user.email,
    },
    isFormSubmitting: Register.isFormSubmitting,
});

export default connect(mapStateToProps, dispatchToProps)(RegisterForm);
